import { z } from 'zod';
import { IsoTimestampSchema, UuidSchema } from './primitives.js';
import { AccountReviewStatusSchema, AccountReviewTriggerSchema, AccountReviewTypeSchema, } from './enums.js';
/**
 * USP #1 — Account Health record.
 *
 * Two fields are crucial for compliance hygiene:
 *  - `reason_public`: what we can legally say to the user
 *  - `reason_internal`: ops/compliance notes, NEVER returned by an API to a user
 *
 * The split exists because tipping-off is a criminal offence
 * (COMPLIANCE-PLAYBOOK §4.4 and §7.3).
 */
export const AccountReviewSchema = z.object({
    id: UuidSchema,
    account_id: UuidSchema,
    type: AccountReviewTypeSchema,
    status: AccountReviewStatusSchema,
    triggered_by: AccountReviewTriggerSchema,
    /** Safe to surface in the user UI. */
    reason_public: z.string().nullable(),
    /** Internal-only — never serialised to the user. */
    reason_internal: z.string(),
    estimated_resolution_at: IsoTimestampSchema.nullable(),
    started_at: IsoTimestampSchema,
    resolved_at: IsoTimestampSchema.nullable(),
    escalated_at: IsoTimestampSchema.nullable(),
    human_review_assigned_to: UuidSchema.nullable(),
});
/** Subset that is safe to return from a user-facing API. */
export const PublicAccountReviewSchema = AccountReviewSchema.pick({
    id: true,
    type: true,
    status: true,
    reason_public: true,
    estimated_resolution_at: true,
    started_at: true,
    resolved_at: true,
});
//# sourceMappingURL=account-review.js.map